const BASE_SPACING_UNIT = 4

/**
 * Convenience function used to generate consistent spacing values
 * @param value - Multiplier to use for spacing
 * @returns string
 */
export function spacing(value: number): string {
  return `${BASE_SPACING_UNIT * value}px`
}
/*
  SPACING TOKENS - Not to be used directly
*/

const _baseUnit0 = spacing(0)
const baseUnit1 = spacing(1)
const baseUnit2 = spacing(2)
const baseUnit3 = spacing(3)
const baseUnit4 = spacing(4)
const baseUnit5 = spacing(5)
const baseUnit6 = spacing(6)
const _baseUnit7 = spacing(7)
const baseUnit8 = spacing(8)
const baseUnit10 = spacing(10)
const baseUnit12 = spacing(12)
const _baseUnit15 = spacing(15)
const _baseUnit20 = spacing(20)

/*
  SEMANTIC SPACING UNITS (use these!)
*/

// BUTTON SPACING

export const button_vSpacingSlim = baseUnit2
export const button_hSpacingSlim = baseUnit4
/** FIGMA: `buttons/button-v-spacing` */
export const button_vSpacing = baseUnit3
/** FIGMA: `buttons/button-h-spacing` */
export const button_hSpacing = baseUnit8
/** FIGMA: `buttons/button-h-gap-spacing` */
export const button_hGapSpacing = baseUnit1

// LAYOUT SPACING

/** FIGMA: `layout/default-content-spacing` */
export const layout_defaultContentSpacing = baseUnit6
/** FIGMA: `layout/page-gutter` */
export const layout_pageGutter = baseUnit12

// LIST SPACING

/** FIGMA: `list/list-item-h-gap` */
export const list_listItemHGap = baseUnit1
/** FIGMA: `list/list-item-v-gap` */
export const list_listItemVGap = baseUnit2
/** FIGMA: `list/list-item-h-padding` */
export const list_listItemHPadding = baseUnit5
/** FIGMA: `list/list-item-v-padding` */
export const list_listItemVPadding = baseUnit4

// NAVIGATION / DESKTOP SPACING

/** FIGMA: `navigation/desktop/nav-item-expanded-h-spacing` */
export const nav_desktop_navItemExpandedHSpacing = baseUnit4
/** FIGMA: `navigation/desktop/nav-item-minimized-h-spacing` */
export const nav_desktop_navItemMinimizedHSpacing = baseUnit1
/** FIGMA: `navigation/desktop/nav-item-space-between` */
export const nav_desktop_navItemSpaceBetween = baseUnit3
/** FIGMA: `navigation/desktop/nav-item-child-h-spacing` */
export const nav_desktop_navItemChildHSpacing = baseUnit10
/** FIGMA: `navigation/desktop/nav-anchor-h-spacing` */
export const nav_desktop_navAnchorHSpacing = baseUnit5
/** FIGMA: `navigation/desktop/nav-anchor-minimized-h-spacing` */
export const nav_desktop_navAnchorMinHSpacing = baseUnit2
/** FIGMA: `navigation/desktop/nav-container-v-spacing` */
export const nav_desktop_navContainerVSpacing = baseUnit3
/** FIGMA: `navigation/desktop/nav-container-items-v-spacing` */
export const nav_desktop_navContainerItemsVSpacing = baseUnit1

// NAVIGATION / MOBILE SPACING

/** FIGMA: `navigation/mobile/nav-item-expanded-h-spacing` */
export const nav_mobile_navItemExpandedHSpacing = baseUnit4
/** FIGMA: `navigation/mobile/nav-item-child-h-spacing` */
export const nav_mobile_navItemChildHSpacing = baseUnit10
/** FIGMA: `navigation/mobile/nav-container-items-v-spacing` */
export const nav_mobile_navContainerItemsVSpacing = baseUnit1

// PILL SPACING

/** FIGMA: `pill/pill-corner-radius` */
export const pill_pillCornerRadius = baseUnit1

// TABLE SPACING

/** FIGMA: `table/table-cell-h-padding` */
export const table_cellHPadding = baseUnit4
/** FIGMA: `table/table-cell-v-padding` */
export const table_cellVPadding = baseUnit4
/** FIGMA: `table/table-header-footer-cell-v-padding` */
export const table_headerFooterCellVPadding = baseUnit3
/** FIGMA: `table/table-cell-h-gap` */
export const table_cellHGap = baseUnit2
/** FIGMA: `table/table-cell-v-gap` */
export const table_cellVGap = baseUnit1
/** FIGMA: `table/table-border-radius` */
export const table_borderRadius = baseUnit3

// FLYOUT SPACING

/** FIGMA: `flyout/outer-block-v-spacing` */
export const flyout_outerBlockVSpacing = baseUnit6
/** FIGMA: `flyout/inner-block-v-spacing` */
export const flyout_innerBlockVSpacing = baseUnit4
/** FIGMA: `flyout/header-v-spacing` */
export const flyout_headerVSpacing = baseUnit5

/** FIGMA: `corner-radius` */
export const cornerRadius = baseUnit2
